import { getCookie } from 'public/assets/js/analytics/cookie';

const COUNTRY_CODE = /^[A-Za-z]{2}$/;

/**
 * The visitor's country from CloudFront, which the webdev-lambdas
 * origin-request handler writes into the `locale` cookie as `countryCode`. It
 * arrives with the page, so it is available on the first render, seconds before
 * OneTrust. Null when the response predates that field or the cookie is
 * missing.
 */
export const getCloudFrontViewerCountry = (): string | null => {
  const raw = getCookie('locale');
  if (!raw) {
    return null;
  }

  try {
    const locale: unknown = JSON.parse(decodeURIComponent(raw));
    const country =
      locale && typeof locale === 'object' && 'countryCode' in locale
        ? locale.countryCode
        : null;
    return typeof country === 'string' && COUNTRY_CODE.test(country)
      ? country.toUpperCase()
      : null;
  } catch {
    return null;
  }
};
